"use strict";

angular.module("vendor")
.component("zoneFilter", {
    templateUrl: require("./zone-filter.component.html"),
    controllerAs: "zoneFilterCtrl",
    controller: function(
        $scope, $stateParams, $filter, ZoneService, StateExtensionService, ModalService
    ) {
        $scope.zones = [];

        this.openZoneSelectorModal = function() {
            ModalService.showModal({
                templateUrl: require("./zone-selector.modal.html"),
                controller: "zoneSelectorModalController",
                controllerAs: "zoneSelectorModalCtrl",
                inputs: {
                    $attrs: {
                        zones: $scope.zones
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(result) {
                    if (result) {
                        $scope.zones = result;
                        refreshZones();
                    }
                    modal.element.remove();
                });
            });
        };

        this.removeFilter = function(zoneId) {
            var zoneToRemove = $filter("filter")($scope.zones, {id: zoneId}, true)[0];
            if (zoneToRemove) {
                var zoneIndex = $scope.zones.indexOf(zoneToRemove);
                if (zoneIndex !== -1) {
                    $scope.zones.splice(zoneIndex, 1);
                    refreshZones();
                }
            }
        };

        this.clearAll = function() {
            $scope.zones = [];
            $scope.$emit("zoneFilterUpdated", {zones: null});
        };

        function refreshZones() {
            var zoneIds = ZoneService.getFilterIdParameter($scope.zones);
            if (!zoneIds) zoneIds = null;
            $scope.$emit("zoneFilterUpdated", {zones: zoneIds});
        }

        if ($stateParams.zones) {
            ZoneService.retrieveZones($stateParams.zones).then(
                function onSuccess(response) {
                    $scope.zones = response.data;
                }
            );
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/zone-filter/zone-filter.component.js
// module id = 826
// module chunks = 0